const easeInOutSin = (time: number): number => {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
};

interface AnimateElementByPropArgs {
  propToAnimate: string;
  element: any;
  moveTo: number;
  duration?: number;
}

interface AnimateElementByPropReturnValue {
  cancel(): void;
  updateBy(target: number): void;
  done: Promise<void>;
}

export function animateElementByProp({
  propToAnimate,
  element,
  moveTo,
  duration = 700,
}: AnimateElementByPropArgs): AnimateElementByPropReturnValue {
  const ease = easeInOutSin;
  const startPoint: any = element[propToAnimate];
  let start: number | null = null;
  let doneResolve: any;
  const done: Promise<void> = new Promise(res => {
    doneResolve = res;
  });
  let animationId: any = null;

  const cancel = () => {
    cancelAnimationFrame(animationId);
  };

  const updateBy = (newTarget: number) => {
    moveTo += newTarget;
  };

  const step = (timestamp: number) => {
    if (start === null) {
      start = timestamp;
    }

    const time = Math.min(1, (timestamp - start) / duration);
    element[propToAnimate] = startPoint + ease(time) * (moveTo - startPoint);

    if (time === 1) {
      start = null;
      doneResolve();
    } else {
      animationId = requestAnimationFrame(step);
    }
  };

  if (startPoint !== moveTo) {
    animationId = requestAnimationFrame(step);
  }

  return {
    cancel,
    updateBy,
    done,
  } as AnimateElementByPropReturnValue;
}
